import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TransferStateInterceptor } from '@core/interceptors/transfer-state.interceptor';


import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EntityDataModule, DefaultDataServiceConfig } from '@ngrx/data';
import { entityConfig, defaultDataServiceConfig } from './store/entity/entity-metadata';
import { appReducers } from './store/reducers/app.reducers';
import { storageSyncMetaReducer } from 'ngrx-store-persist';
import { EncodeService } from '@core/services/encode.service';
import {EnvConfigurationService} from '@core/services/env-configuration.service';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserTransferStateModule,
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    SharedModule,
    StoreModule.forRoot(appReducers,
      {
        metaReducers: [storageSyncMetaReducer],
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true
        },

      }
    ),
    EffectsModule.forRoot([]),
    EntityDataModule.forRoot(entityConfig),
  ],
  providers: [
    {
      provide: DefaultDataServiceConfig,
      useValue: defaultDataServiceConfig
      // deps: [EnvConfigurationService]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (envConfigService: EnvConfigurationService) => () => envConfigService.load(),
      deps: [EnvConfigurationService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TransferStateInterceptor,
      multi: true
    },
    EncodeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
